import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { Validator } from '@/services/vee-validate';
import moment from 'moment';

import http from '@/http';
import fr from './locales/fr';

Vue.use(VueI18n);

const loadedLocales = ['fr'];

const i18n = new VueI18n({
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: {
    fr,
  },
});

Validator.localize({ fr: fr.veeValidate });

function setI18nLocale(locale) {
  i18n.locale = locale;
  http.defaults.headers.common['Accept-Language'] = locale;
  document.querySelector('html').setAttribute('lang', locale);
  Validator.localize(locale);
  moment.locale(locale);
  return locale;
}

// ToDo get locale from config
setI18nLocale('fr');

export async function loadLanguageAsync(locale) {
  if (i18n.locale !== locale) {
    if (!loadedLocales.includes(locale)) {
      const msgs = await import(/* webpackChunkName: "locale-[request]" */ `./locales/${locale}`);
      i18n.setLocaleMessage(locale, msgs.default);
      Validator.localize(locale, msgs.veeValidate);
      loadedLocales.push(locale);
      return setI18nLocale(locale);
    }
    return setI18nLocale(locale);
  }
  return locale;
}

export default i18n;

if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    module.hot.accept(['./locales/fr', './locales/en'], () => {
      i18n.setLocaleMessage('fr', require('./locales/fr').default); // eslint-disable-line global-require
      i18n.setLocaleMessage('en', require('./locales/en').default); // eslint-disable-line global-require
    });
  }
}
